{
  "version": 1,
  "asset_id": "002d985b-ac9c-4d2f-a842-e78e29ad582a",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/002d985b-ac9c-4d2f-a842-e78e29ad582a/mark-256.png",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/002d985b-ac9c-4d2f-a842-e78e29ad582a/mark-256.png",
  "original_filename": "mark-256.png",
  "size": 22112,
  "content_type": "image/png",
  "created_at": "2026-07-25T02:18:23Z"
}
